/**
 * @author Blueprint Frontend Team
 */
import "../scss/index.scss";
import { header } from './layouts';
import { slider, tabs, accordion, lightbox, pageAnim, customFormInp, activityDate, historyText, phoneFormat } from './components';

import { loadPage } from './utils';

(function () {
  loadPage.init();

  // Layouts
  header.init();


  // Partials Modules
  slider.init();
  tabs.init();
  accordion.init();
  lightbox.init();
  pageAnim.init();
  customFormInp.init();
  activityDate.init();
  historyText();
  phoneFormat.init();
  // Page Modules
}());
